import { Link } from 'react-router-dom';
import { Linkedin, Mail, FileText } from 'lucide-react';
import { NewsletterForm } from '../forms/NewsletterForm';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/writing', label: 'Research & Writing' },
    { path: '/consulting', label: 'Consulting' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <footer className="bg-[#2C3E50] text-white" data-testid="footer">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="space-y-4">
            <h3 className="font-['Montserrat'] font-bold text-xl">Siddharth Kaul</h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              Cloud, SRE, DevOps & AI Infrastructure
            </p>
            <p className="text-slate-400 text-sm leading-relaxed">
              Helping enterprise leaders modernize infrastructure and optimize AI workloads.
            </p>
          </div>

          {/* Quick Links Column */}
          <div className="space-y-4">
            <h4 className="font-['Montserrat'] font-semibold text-base">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-300 text-sm hover:text-[#3498DB] transition-colors duration-200"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect & Newsletter Column */}
          <div className="space-y-6">
            <div className="space-y-4">
              <h4 className="font-['Montserrat'] font-semibold text-base">Connect</h4>
              <div className="flex gap-4">
                <a
                  href="https://linkedin.com/in/siddharth-k-8b41b619"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-300 hover:text-[#3498DB] transition-colors duration-200"
                  data-testid="footer-linkedin"
                >
                  <Linkedin size={20} />
                </a>
                <a
                  href="https://siddharthkaul.substack.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-300 hover:text-[#3498DB] transition-colors duration-200"
                  data-testid="footer-substack"
                >
                  <FileText size={20} />
                </a>
                <a
                  href="mailto:sidd@siddharthkaul.com"
                  className="text-slate-300 hover:text-[#3498DB] transition-colors duration-200"
                  data-testid="footer-email"
                >
                  <Mail size={20} />
                </a>
              </div>
            </div>

            <div className="space-y-4">
              <h4 className="font-['Montserrat'] font-semibold text-base">Newsletter</h4>
              <NewsletterForm variant="footer" />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-600">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {currentYear} Siddharth Kaul. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-slate-400 text-sm hover:text-white transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-slate-400 text-sm hover:text-white transition-colors duration-200">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
